export default  {"src":"/_next/static/image/public/assets/icons/search.f3e87838a7bc118c8e1735c430dd24cd.svg","height":28,"width":28};